<template>
    <section id="contact-popup">
        <div id="container-contacts-form" class="container d-flex">
            <div class="text-align-start formHeader">
                <img src="/imgs/icons/adv-logo-sm.png" alt="Advance Management Logo" style="max-width: 2em; margin-right: .5em">
                <span style="vertical-align: middle; font-weight: 600">Contatos</span>
            </div>
            <div id="div-title">
                <i class="fa fa-address-book fa-2x" aria-hidden="true" style="color: rgb(28,134,154)"></i>
                <h2 id="container-title">Cadastro de Contatos</h2>
            </div>
            <form action="" id="contacts-form">
                <div class="input-group">
                    <label for="contactName">Nome</label>
                    <input 
                        class="form-control" 
                        name="contactName" 
                        type="text" 
                        v-model="contact.name" 
                        placeholder="Insira o nome do contato" 
                        required>
                </div>
                <div class="input-group">
                    <label for="contactName">Nome da Empresa</label>
                    <input 
                        class="form-control" 
                        name="companyName" 
                        type="text" 
                        v-model="contact.company_name" 
                        placeholder="Insira o nome da empresa" 
                        required>
                </div>
                <div class="input-group">
                    <label for="contactPhone">Telefone</label>
                    <vue-tel-input 
                        id="phone-input" 
                        :inputOptions="options"
                        defaultCountry=""
                        mode="international" 
                        v-model="contact.phone">
                    </vue-tel-input>
                </div>
                <div class="input-group mt-2">
                    <select class="form-control mr-3 ml-3" name="id-cpf" id="id-cpf" v-model="idCpf" style="flex: 1">
                        <option value="cpf">CPF</option>
                        <option value="cnpj">CNPJ</option>
                    </select>
                    <input v-if="idCpf == 'cpf'"
                        class="form-control" 
                        name="contactKey" 
                        type="text" 
                        v-model="contact.unique_key"
                        v-mask="'###.###.###-##'"
                        placeholder="XXX.XXX.XXX-XX"
                        style="flex: 4"
                    >
                    <input v-if="idCpf == 'cnpj'"
                        class="form-control"
                        name="contactKey"
                        type="text"
                        v-model="contact.unique_key"
                        v-mask="'##.###.###/####-##'"
                        placeholder="XX.XXX.XXX/XXXX-XX"
                        style="flex: 4"
                    >
                </div>

                <!-- <div class="input-group">
                    <label for="contactEquipe">Fila</label>
                     <select v-on:change="contactCOption($event)" class="form-control" name="contactEquipe" id="contactEquipe" v-model="contact.equipe" style="flex: 1" required>
                        <option v-for="item in contactEquipeOption" :key="item.fila" :value="item.fila">{{ item.fila }}</option>
                    </select>
                </div> -->

                <!-- <div class="input-group">
                    <label for="contactConsultor">Consultor</label>
                    <select class="form-control" name="contactConsultor" id="contactConsultor" 
                            v-model="contact.operator" style="flex: 1" required>
                        <option disabled value="">Selecione um Consultor</option>
                        <option v-for="item in contactConsultorOption" 
                                :key="item.extension_line" 
                                :value="item.extension_line">
                            {{ item.name }}
                        </option>
                    </select>
                </div> -->

                <div v-if="saving">
                    <p id="saving"><strong><i class="fas fa-spinner fa-pulse"></i> Salvando contato...</strong></p>
                </div>
                <div v-else >
                    <button    
                        type="submit"
                        class="btn btn-success"
                        id="btn-save"
                        form="chamadoForm"
                        @click.prevent="saveContact()"
                    ><i class="fas fa-check"></i>
                        Salvar
                    </button>
                    <button 
                        type="submit"
                        class="btn btn-danger"
                        id="btn-cancel"
                        form="chamadoForm"
                        @click.prevent="resetContact()"
                    ><i class="fas fa-window-close fa-fw"></i>
                        Cancelar
                    </button>
                </div>
            </form>
        </div>
    </section>
</template>
    
<script>

import {mapActions, mapGetters, mapMutations} from 'vuex';
import swal from 'sweetalert';
import VueTheMask from 'vue-the-mask'
Vue.use(VueTheMask)

export default {
    name: "ContatosRapido",
    props: ['addWppContact'],
    data(){
        return {
            contact: {
                name: "",
                company_name: "",
                phone: "",
                unique_key: "",
                equipe: "",
                operator: ""
            },
            saving: false,
            idCpf: "cpf",
            options: {
                placeholder: 'Insira o telefone',
                required: true
            },
            returnContacts: [],
            contactEquipeOption: '',
            contactConsultorOption: [{"extension_line":"0","name":"Selecione uma Fila"}],
        }
    },
    components: {
        ...mapGetters(['getContacts']),
    },
    created() {
        axios.get('/queue-contacts').then(({data}) => {
            this.contactEquipeOption = data;

            // Garantir que `contactConsultorOption` seja único ao carregar
            if (data.length > 0) {
                this.contactConsultorOption = data[0].operadores.filter(
                    (operador, index, self) =>
                        index === self.findIndex(o => o.extension_line === operador.extension_line)
                );
            }
        });

    },
    methods:{
        contactCOption(event) {
            let equipe = event.target[event.target.selectedIndex].label || this.contact.equipe;

            // Filtrar a equipe correspondente e remover duplicados
            Object.keys(this.contactEquipeOption).forEach(key => {
                if (this.contactEquipeOption[key].fila.includes(equipe)) {
                    this.contactConsultorOption = this.contactEquipeOption[key].operadores.filter(
                        (operador, index, self) =>
                            index === self.findIndex(o => o.extension_line === operador.extension_line)
                    );
                }
            });

        },
        contactExist: async function (phone) {
            try {
                const { data } = await axios.get(`/api/share-client-cnpj?share=${phone}`);
                this.returnContacts = data[0];
                return true; // Contato encontrado
            } catch (error) {
                console.error(error);
                return false; // Contato não encontrado
            }
        },
        checkForm: function(){
            if (this.contact.name == ''){
                Swal.fire({
                    html: 'O campo "Nome" não foi preenchido!',
                    type: "warning",
                    showCloseButton: true,
                    confirmButtonText: '<i class="fa fa-thumbs-up"></i>'
                });
                return false  
            }
            if (this.contact.phone == ''){
                Swal.fire({
                    html: 'O campo "Telefone" não foi preenchido!',
                    type: "warning",
                    showCloseButton: true,
                    confirmButtonText: '<i class="fa fa-thumbs-up"></i>'
                });
                return false  
            }
            return true
        },
        saveContact: async function () {
            if (this.checkForm()) {
                this.saving = true;

                if(this.returnContacts && this.returnContacts?.id){
                        axios.post('/update-contacts', {
                            id: this.returnContacts.id, 
                            name: this.contact.name, 
                            company_name: this.contact.company_name, 
                            phone: this.contact.phone, 
                            unique_key: this.contact.unique_key, 
                            filter: this.contact.filter, 
                            equipe: this.contact.equipe,
                            operator: this.contact.operator
                        }).then(data => {
                            Swal.fire({
                            type: "success",
                            title: "Feito!",
                            html: `Contato atualizado com sucesso! <br><br> 
                            <strong>Atenção!</strong><br><br> 
                            As alterações feitas no contato só serão refletidas ao iniciar uma <em>nova sessão</em>!`
                        }).then(comfirm =>{
                            this.saving = false
                            this.contact.name = "";
                            this.contact.company_name = "";
                            this.contact.phone = "";
                            this.contact.unique_key = "";
                            this.idCpf = "cpf";
                            this.contact.operator = "";
                            this.contact.equipe = "";
                            this.$emit('closeContacts')
                        });  
                    });
                }else{
                    axios.post("dialer/saveContact", this.contact).then(response => {
                        if (response.data.passed == false) {
                            let str = '';
                            Object.keys(response.data.errors).forEach(key => {
                                str += response.data.errors[key];
                            });
                            Swal.fire({
                                type: "warning",
                                title: "Não foi possível inserir o cliente na base",
                                text: str
                            });
                        } else {
                            Swal.fire({
                                type: "success",
                                title: "Feito!",
                                text: "Contato salvo com sucesso!"
                            });
                        }

                        // Resetar os campos após o sucesso
                        this.contact.name = "";
                        this.contact.company_name = "";
                        this.contact.phone = "";
                        this.contact.unique_key = "";
                        this.idCpf = "cpf";
                        this.contact.equipe = "";
                        this.contact.operator = "";
                        this.$emit('closeContacts');
                    })
                    .catch(error => {
                        console.error("Erro ao salvar o contato:", error);
                        Swal.fire({
                            type: "error",
                            title: "Erro",
                            text: "Falha ao salvar o contato na base de dados."
                        });
                    })
                    .finally(() => {
                        this.saving = false;
                    });
                }
            }
        },

        resetContact: function(){
            Swal.fire({
                title: 'Deseja descartar as informações?',
                text: 'Você perderá as alterações não salvas!',
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#d33',
                cancelButtonColor: 'rgb(28,134,154)',
                confirmButtonText: 'Sim, descartar',
                cancelButtonText: 'Voltar ao formulário'
            }).then((result) => {
                if(result.value){
                  	  this.contact.name = "";
                      this.contact.company_name = "";
                  	  this.contact.phone = "";
                      this.contact.unique_key =  "";
                      this.idCpf = "cpf";
                      this.contact.operator = "";
                      this.contact.equipe = "";
                    this.$emit('closeContacts');
                }
            })
        },
        async setClientData(client) {	
			if( (client.phone || client.name) && client.type == 'chat'){		
                
                let phoneArr = client.phone.split('@');
				let phoneEdited = phoneArr[0].substr(2);

				this.contact = {
					'name': client.name,
					'phone': phoneEdited,
				}
			}
		}
    },
    computed:{
		...mapGetters([
			'getContacts',
		]),
		...mapActions(['setMessage']),
    },

    watch: {
        idCpf() {
            this.contact.unique_key = "";
        },
        async addWppContact (data){

            if(data){
                const phone = data.phone
                const phoneEdited = '+' + phone ;
            
                const exists = await this.contactExist(phoneEdited);

                if (exists && this.returnContacts) {

                    this.contact = {
                        name: this.returnContacts.name,
                        company_name: this.returnContacts?.company_name,
                        phone: this.returnContacts.phone,
                        unique_key: this.returnContacts.unique_key,
                        equipe: this.returnContacts.equipe,
                        operator: this.returnContacts.operator
                    };
                }else{
                    this.contact = {
                        'name': data.name,
                        'phone': phoneEdited,
                    }
                }
            }
        },
        
    }
}
</script>

<style scoped>
    #contact-popup{
        display: flex;
        justify-content: center;
        position: absolute;
        top: 55px;
        right: 25vw;
    }
    .formHeader {
        background-color: rgb(28,134,154);
        border-top: 3px solid #f38630;
        color: white;
        padding: 0.2em;
        display: flex;
        border-radius: 20px 20px 0px 0px
    }

    .input-group{
        width: 90%;
        align-self: center;
        line-height: 2.55;
        display: flex;
        justify-content: space-around;
    }

    #container-contacts-form{
        width: 35vw;
        border: solid 2px lightgray;
        border-radius: 25px;
        text-align: center;
        flex-direction: column;
        margin: 10px;
        padding: 0;
        background-color: white;

    }

    #saving {
        color: rgb(28,134,154);
        font-size: 16px;
        text-align: center
    }

    #div-title {
        display: flex;
        flex-direction: column;
        margin: 20px;
    }

    #contacts-form{
        display: flex;
        flex-direction: column;
        text-align: center;
    }

    #buttonGroup {
        display: flex;
        justify-content: center;
    }

    #btn-save {
        border: solid 2px #008000;
        border-radius: 20px;
        background-color: #008000;
        color: white;
        transition: 0.5s
    }
    
    #btn-save:hover {
        color: #008000;
        background-color: white;

    }

    #btn-cancel {
        border: solid 2px #b30000;
        border-radius: 20px;
        background-color: #b30000;
        color: white;
        transition: 0.5s
    }
    
    #btn-cancel:hover {
        color: #b30000;
        background-color: white;
    }

    #phone-input{
        height: 2.5em;
        align-self: center;
        flex: 3;
    }

    section {
        display: flex;
        justify-content: center;
    }

    h2 {
        color: rgb(28,134,154)
    }

    label{
        margin: 10px;
        font-size: 16px;
        font-weight: 500;
    }

    select {
        align-self: center;
    }

    input {
        width: 40px;
        align-self: center;
    }

    button {
        width: 120px;
        margin: 20px;
        border-radius: 10px !important
    }
</style>